function init() {
    const inputs = Array.from<HTMLInputElement>(document.querySelectorAll('.tab-item__input'));
    const btn = document.querySelector<HTMLFormElement>('.form-button');
    let selectedFilters = [];

    if (inputs.length > 0 && inputs.slice(1).every((input) => !input.checked)) {
        if (inputs[0]) {
            inputs[0].checked = true;
        }
    }

    const updateFilter = () => {
        const selectedTypes = inputs.reduce((res, cur) => {
            if (cur.checked) {
                res.push(cur.name);
            }
            return res;
        }, [] as string[]);

        return selectedTypes;
    };

    const updateURL = () => {
        selectedFilters = updateFilter();

        const qp = new URLSearchParams();

        qp.delete('filter');

        selectedFilters.forEach((filter) => qp.append('filter', filter));

        history.replaceState(null, '', '?' + qp.toString());
    };

    btn?.addEventListener('click', () => {
        updateURL();
    });
}

const _module = { init };

export default _module;
